module.exports = __webpack_public_path__ + "img/referral.8424eb9d.svg";